var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"range-year-slider hide-for-print",class:{ 'isRangeSameYear' : (_vm.isRangeSameYear() === true), 'isRange' : (_vm.isRangeSlider() === true) },attrs:{"id":"range-year-slider"}},[_c('vue-slider',{ref:"slider",staticClass:"range-year-slider__slider",attrs:{"lazy":true,"max":_vm.maxYear,"min":_vm.minYear,"piecewise":true,"piecewise-label":true,"piecewiseStyle":{
        "backgroundColor": "#2F3E5E",
        "width": "4px",
        "height": "4px"
      },"tooltipStyle":[
        {
          "backgroundColor": "#F1F3F7",
          "borderColor": "#F1F3F7",
          "boxShadow": "0 0 10px 0 RGBA(0,0,0,0.1)",
          "color": "#2F3E5E",
          "font-size": "14px",
          "border-radius": "3px"
        },
        {
          "backgroundColor": "#F1F3F7",
          "borderColor": "#F1F3F7",
          "color": "#2F3E5E",
          "font-size": "14px",
          "border-radius": "3px"
        }
      ],"tooltip":"hover","tooltip-dir":"top"},model:{value:(_vm.current),callback:function ($$v) {_vm.current=$$v},expression:"current"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59143b25","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/sliders/RangeYearSlider.vue
// module id = 348
// module chunks = 0